<template>
  <el-dialog
    :visible.sync="diaIsShow"
    :close-on-click-modal="false"
    top="12vh"
    width="835px"
    class="adjust-stus-dialog"
  >
    <div class="slot-dialog-header" slot="title">
      <div class="drag_title">
        <span class="title">调整分组</span>
        <span class="prompt">注：如需人工调整，拖动学员姓名至其他分组互换位置即可~</span>
      </div>
      
      <div class="header_sel">
        <span>分组方式</span>
        <el-select
          v-model="g_type"
          @change="groupChange"
          placeholder="请选择分组方式"
          size="small"
          class="g_sel"
        >
          <el-option
            v-for="item in groupType"
            :key="item.val"
            :label="item.label"
            :value="item.val"
          ></el-option>
        </el-select>
        <template v-if="classLevel && classLevel !== 'D' && classLevel !== 'early'">
          <el-popover placement="top" width="180" v-model="againShow">
            <p>确定进行二次分组？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="againShow = false">取消</el-button>
              <el-button type="primary" size="mini" @click="againList()">确定</el-button>
            </div>
            <el-button size="small" type="primary" slot="reference">二次分组</el-button>
          </el-popover>
        </template>
      </div>
    </div>
    <div v-if="diaIsShow" class="content">
      <el-row class="container">
        <el-col :span="24" class="stu-col">
          <vue-scroll :ops="scrollOpt" ref="vScroll">
            <div class="wrap">
              <template v-if="showGroup">
                <div v-for="(group, index) in tempList" :key="group.group_id" class="group">
                  <div class="title">{{group.name}}</div>
                  <draggable
                    class="user-wrap"
                    element="ul"
                    :options="dragOptions"
                    :ref="`group${index}`"
                  >
                    <li
                      class="user"
                      v-for="user in group.stu_list"
                      :key="user.user_id"
                      :data-group="index"
                      :data-id="user.user_id"
                    >
                      <p class="user_name">{{user.user_name}}</p>
                    </li>
                  </draggable>
                </div>
              </template>
              <yioks-loading v-else></yioks-loading>
            </div>
          </vue-scroll>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="5">
          <el-row type="flex" justify="space-between">
            <el-button type="primary" @click="saveAdjust">保存</el-button>
            <el-button type="danger" @click="cancelAdjust">取消</el-button>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import scrollOpt from "@/assets/js/vuescrollOption";
import draggable from "vuedraggable";
export default {
  name: "hello",
  props: {
    ifDiaShow: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    classLevel: {
      type: String
    }
  },
  data() {
    return {
      scrollOpt: scrollOpt(true),
     /* groupType,
      nameList,*/
      g_type: 3,
      user: null,
      showGroup: true,
      againShow: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: "user",
        ghostClass: "ghost"
      };
    },
    diaIsShow: {
      get() {
        return this.ifDiaShow;
      },
      set(bool) {
        this.$emit("update:ifDiaShow", bool);
      }
    },
    tempList: {
      get() {
        const templist = [];
        if(this.list.length) {
          this.list.forEach(item => {
            if(item.name !== '补考组') {
              templist.push(item)
            }
          })
        }
        this.g_type = (templist.length / 2) || 0;
        return templist;
      },
      set(arr) {
        this.$emit("update:list", arr);
      }
    },
    groupType(){
      let groupType = [
        {label: "六组/三组", val: 3},
        {label: "八组/四组", val: 4}
      ];
      if (this.classLevel && this.classLevel !== 'D' && this.classLevel !== 'early' ){
        groupType = [
          {label: "六组", val: 3},
          {label: "八组", val: 4}
        ];
      }
      return groupType;
    },
    nameList(){
      let nameList = [
        "A1组",
        "A2组",
        "B1组",
        "B2组",
        "C1组",
        "C2组",
        "D1组",
        "D2组"
      ];
      if (this.classLevel && this.classLevel !== 'D' && this.classLevel !== 'early') {
        nameList = [
          "1组",
          "2组",
          "3组",
          "4组",
          "5组",
          "6组",
          "7组",
          "8组"
        ];
      }
      return nameList;
    }
  },
  components: {
    draggable,
    "yioks-loading": () => import("@/components/Loading/Loading")
  },
  methods: {
    againList() {
      this.againShow = false;
      this.showGroup = false;
      const tempList = this.tempList
      const container = tempList.map(({c_id, group_id, name}) => ({c_id, group_id, name, stu_list: []}));
      const flattenList = this.computedUser(tempList);
      const average = parseInt(flattenList.length/container.length)
      flattenList.forEach((item, i) => {
        container[i%(container.length)].stu_list.push(item)
      })
      // const names = flattenList.map(({user_name}) => (user_name));
      // const stuList = container.map(({stu_list}) => (stu_list.map(({user_name}) => (user_name))))
      // console.log(names, stuList)
      this.tempList = JSON.parse(JSON.stringify(container));
      this.showGroup = true;
    },
    computedUser(arr) {
      let all_user = [];
      arr.map(item => {
        all_user.push(...item.stu_list);
      });
      return all_user;
    },
    handleAdjustData() {
      return this.tempList.map((temp, i) => {
        const group = this.$refs[`group${i}`][0].$el.childNodes;
        const id = Array.from(group).map(item => item.dataset.id);
        return {
          group_id: i + 1,
          stu_id: id.join(",")
        };
      });
      // const len = this.tempList.length;
      // let groupList = [];
      // for (let i = 0; i < len; i++) {
      //   // let id = [];
      //   const group_id = i + 1;
      //   const group = this.$refs[`group${i}`][0].$el.childNodes;
      //   const id = Array.from(group).map((item) => (item.dataset.id));
      //   groupList.push({
      //     group_id,
      //     stu_id: id.join(","),
      //   });
      // }
      // return groupList;
    },
    groupChange(val) {
      this.showGroup = false;
      const all_user = this.computedUser(this.tempList);
      const len = all_user.length;
      let arr = [];
      const average = parseInt(len / (val * 2));
      for (let i = 0; i < val * 2; i++) {
        arr[i] = all_user.splice(0, average);
      }
      const more = len % (val * 2);
      if (more !== 0) {
        for (let j = 0; j < more; j++) {
          arr[arr.length - 1 - j].push(all_user[j]);
        }
      }
      // let listArr = [];
      const listArr = arr.map((item, index) => ({
        group_id: index + 1,
        name: this.nameList[index],
        stu_list: item
      }));
      this.tempList = JSON.parse(JSON.stringify(listArr));
      setTimeout(() => {
        this.showGroup = true;
      }, 500);
    },
    saveAdjust() {
      const arr = this.handleAdjustData();
      const flag = arr.every(({stu_id}) => (stu_id !== ""));
      // let flag = true;
      // arr.map(({ stu_id }) => {
      //   if (stu_id === "") flag = false;
      // });
      if (flag) this.$emit("save", arr);
      else this.$message.error("每组至少一个人");
    },
    cancelAdjust() {
      this.diaIsShow = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.adjust-stus-dialog {
  .el-dialog__body {
    padding: 0 20px 20px;
  }
  .slot-dialog-header {
    display: flex;
    justify-content space-between
    align-items: center;
    line-height: 1;
    padding-bottom: 10px;
    font-size: 20px;
    border-bottom: 1px solid $color_text_secondary;
    color: $color_text_primary;
    position: relative;
    .drag_title {
      .title {
        margin-right: 15px;
      }
      .prompt {
        color: $color_err;
        font-size: $font_size_base;
      }
    }
    
    .header_sel {
      /*position: absolute;*/
      // top: -5px;
      /*right: 0;*/
      font-size: 16px;
      display: flex;
      align-items: center;
      .g_sel {
        width: 150px;
        margin-left: 10px;
        margin-right: 10px;
      }
      .btn {
        margin-right: 10px;
      }
    }
  }
  .container {
    display: flex;
    margin: 0 0 10px 0;
    .stu-col {
      height: 100%;
      .wrap {
        height: 600px;
        padding: 0 20px 0 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: space-around;
        /*align-content: space-around;*/
        .group {
          width: 45%;
          margin: 0 0 10px 0;
          border: 2px solid $color_suc;
          border-radius: 5px;
          .title {
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid $color_suc;
            background-color: $color_suc;
            color: $color_white;
            font-size: $font_size_big;
            font-weight: bolder;
            user-select: none;
          }
          .user-wrap {
            height: calc(100% - 30px);
            min-height: 45px;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
            .user {
              flex: 0 0 auto;
              width: 45%;
              padding: 5px 0;
              margin: 0 0 10px 0;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid $color_suc;
              cursor: move;
              .user_name {
                word-break break-all
                // word-break break-word
                word-wrap break-word
              }
            }
          }
        }
      }
    }
  }
}
</style>
